import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Flag from './flag-model'
import { CreateFlagAsync, DeleteFlagAsync, LoadFlagsAsync } from './flag-thunk'
const initialState: flagSliceState = {
  flag: [],
  selected_flag: '',
  is_loading_flag: false,
  is_creating_flag: false,
  is_deleting_flag: false,
}
export interface flagSliceState {
  flag: Flag[]
  selected_flag?: string
  is_loading_flag: boolean
  is_creating_flag: boolean
  is_deleting_flag: boolean
}
export const flagSlice = createSlice({
  name: 'flag',
  initialState,
  reducers: {
    setSelectedflag: (state, action) => {
      state.selected_flag = action.payload
    },
    clearStateflag: (state) => {
      state.flag = []
      state.is_loading_flag = false
      state.is_creating_flag = false
      state.is_deleting_flag = false
    },
    mergeflag: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_flag = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.flag = merge(state.flag, payload) as any
        }
      }
    },

    add_flag: (state, action) => {
      if (action.payload) {
        state.flag = [...state.flag, action.payload]
      }
    },
    set_flag: (state, action) => {
      let { key, value, id } = action.payload
      state.flag = state.flag.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadFlagsAsync.pending, (state) => {
      state.is_loading_flag = true
    })
    builder.addCase(LoadFlagsAsync.fulfilled, (state, action) => {
      state.is_loading_flag = false
      if (action.payload) {
        state.flag = action.payload
      }
    })
    builder.addCase(LoadFlagsAsync.rejected, (state) => {
      state.is_loading_flag = false
    })
    builder.addCase(CreateFlagAsync.pending, (state) => {
      state.is_creating_flag = true
    })
    builder.addCase(CreateFlagAsync.fulfilled, (state) => {
      state.is_creating_flag = false
    })
    builder.addCase(CreateFlagAsync.rejected, (state) => {
      state.is_creating_flag = false
    })
    builder.addCase(DeleteFlagAsync.pending, (state) => {
      state.is_deleting_flag = true
    })
    builder.addCase(DeleteFlagAsync.fulfilled, (state, action) => {
      state.is_deleting_flag = false
      if (state.flag) {
        state.flag = state.flag.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteFlagAsync.rejected, (state) => {
      state.is_deleting_flag = false
    })
  },
})

export const {
  clearStateflag,
  setSelectedflag,
  set_flag,
  mergeflag,
  add_flag,
} = flagSlice.actions

export const get_flag =
  (id?: string) =>
  (state: {
    flag: {
      flag: Flag[]
    }
  }): Flag | null => {
    let temp = state?.flag?.flag?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.flag?.flag[0] || null
  }
export const get_selected_flag = (state: {
  flag: flagSliceState
}): Flag | null => {
  let id = state?.flag?.selected_flag
  let temp = state?.flag?.flag?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_flag = (state: {
  flag: {
    flag: Flag[]
  }
}): Flag[] => {
  let temp = state?.flag?.flag
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_flag_busy = (state: { flag: flagSliceState }) => {
  return (
    state?.flag.is_deleting_flag ||
    state?.flag.is_loading_flag ||
    state?.flag.is_creating_flag
  )
}
export const is_deleting_flag_busy = (state: { flag: flagSliceState }) => {
  return state?.flag.is_deleting_flag
}
export const is_loading_flag_busy = (state: { flag: flagSliceState }) => {
  return state?.flag.is_loading_flag
}
export const is_creating_flag_busy = (state: { flag: flagSliceState }) => {
  return state?.flag.is_creating_flag
}

export default flagSlice.reducer
